<div class="table-responsive animated fadeIn slow">
    <div>
        <h2 style="text-align: center;" class="titulo">LISTADO DE EMPLEADOS</h2>
    </div>
    <button type="button" class="btn-agregar" title="AGREGAR RESGUARDANTES" data-toggle="modal" data-target="#Agregarempleado" data-backdrop="static">
            <i class="fas fa-user-plus"></i> AGREGAR RESGUARDANTES
        </button>
    <div class="table-wrapper">
        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="tabla-asignaturas">
            <thead>
                <tr>

                    <th scope="row">Número de empleado</th>
                    <th scope="col">Nombre</th>
                    <th scope="col">Apellido paterno</th>
                    <th scope="col">Apellido materno</th>
                    <th scope="col">CURP</th>
                    <th scope="col">RFC</th>
                    <th scope="col">Activo</th>
                    <th scope="col">Plantel</th>
                    <th scope="col">Ver</th>
                    <th scope="col">Editar</th>
                    <th scope="col">Baja</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let emplea of empleadoss">


                    <td style="text-align: center;">{{emplea.numpersonal}}</td>
                    <td style="text-align: left;">{{emplea.nombre}}</td>
                    <td style="text-align: left;">{{emplea.appaterno}}</td>
                    <td style="text-align: left;">{{emplea.apmaterno}}</td>
                    <td style="text-align: left;">{{emplea.curp}}</td>
                    <td style="text-align: left;">{{emplea.rfc}}</td>
                    <td *ngIf="emplea.esactivo == true">Si</td>
                    <td *ngIf="emplea.esactivo == false">No</td>
                    <td style="text-align: left;">{{emplea.nombreplantel}}</td>
                    <td>
                        <button type="button" class="btn-icon ver" data-toggle="modal" (click)=" verEmpleado(emplea.numpersonal)" data-target="#Verempleado" data-backdrop="static">
                        <i class="fas fa-eye"></i>
                    </button>
                    </td>
                    <td>
                        <button type="button" class="btn-icon editar" data-toggle="modal" (click)=" verEmpleado(emplea.numpersonal)" data-target="#Editarempleado" data-backdrop="static">
                        <i class="fas fa-edit"></i>
                    </button>
                    </td>
                    <td>
                        <button type="button" class="btn-icon eliminar" (click)="eliminarempleado(emplea.numpersonal)">
                        <i class="fas fa-trash-alt"></i>
                    </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

</div>


<div class="modal fade bd-example-modal-lg" id="Agregarempleado" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="dialog">
        <div class="modal-content modal-asig">

            <!-- HEADER -->
            <div class="modal-header-asig">
                <h2 class="modal-title-asig">AGREGAR RESGUARDANTE</h2>
            </div>

            <!-- BODY -->
            <div class="modal-body-asig">
                <div class="container-asig">

                    <!-- SECCIÓN 1 -->
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-4">
                            <label class="label-asig">Número de empleado:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" [(ngModel)]="empleados.numpersonal" size="20" required>
                        </div>
                        <div class="col col-lg-8">
                            <label class="label-asig">Nombre completo:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" placeholder="Nombre completo" [(ngModel)]="empleados.nombre" (ngModelChange)="empleados.nombre = $event.toUpperCase()" size="20" required>
                        </div>

                    </div>
                    <br>
                    <div class="row justify-content-md-center">

                        <div class="col col-lg-6">
                            <label class="label-asig">Apellido paterno:</label>
                            <input type="text" id="clave" class="form-control-asig disabled-asig" placeholder="Apellido paterno" [(ngModel)]="empleados.appaterno" (ngModelChange)="empleados.appaterno = $event.toUpperCase()" size="20" required>
                        </div>
                        <div class="col col-lg-6">
                            <label class="label-asig">Apellido materno:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" placeholder="Apellido materno" [(ngModel)]="empleados.apmaterno" (ngModelChange)="empleados.apmaterno = $event.toUpperCase()" size="20" required>

                        </div>
                    </div>
                    <br>



                    <div class="row justify-content-md-center">
                        <div class="col col-lg-7">
                            <label class="label-asig">RFC:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" placeholder="RFC" [(ngModel)]="empleados.rfc" (ngModelChange)="empleados.rfc = $event.toUpperCase()" size="20" required>
                        </div>
                        <div class="col col-lg-5">
                            <label class="label-asig">Plantel:</label>
                            <select class="form-control-asig disabled-asig" name="Monitor" [(ngModel)]="empleados.idplantel" required> 
                           <option value="0"> Dirección General</option>
                          <option value="1"> Tres Valles</option>
                          <option value="2"> Papantla</option>
                          <option value="3"> Benito Juárez</option>
                          <option value="4"> Naolinco</option>
                          <option value="5"> Vega de Alatorre</option>
                          <option value="6"> Huitzila</option>
                          <option value="7"> Coxquihui</option>
                          <option value="8"> Uxpanapa</option>
                          <option value="9"> Huayacocotla</option>
                          <option value="10"> Agua Dulce</option>
                          <option value="11"> Pajapan</option>
                          <option value="12"> Filomeno Mata</option>
                          <option value="13"> Platón Sánchez</option>
                          <option value="14"> Atzalan</option>
                          <option value="15"> San Rafael</option>
                          <option value="16"> Omealca</option>
                          <option value="17"> Huatusco</option>
                          <option value="18"> La Camelia</option>
                          <option value="19"> Ciudad Olmeca</option>
                          <option value="20"> Las Lomas</option>
                          <option value="21"> Guayalejo</option>
                          <option value="22"> Medellin</option>
                          <option value="23"> La Cuesta</option>
                          <option value="24"> Huazuntlán</option>
                          <option value="25"> Otatitlan</option>
                          <option value="26"> Catemaco</option>
                          <option value="27"> Palma Sola</option>
                          <option value="28"> Veracruz</option>
                          <option value="29"> General Alatriste</option>
                          <option value="30"> Palo Blanco</option>
                          <option value="31"> Coetzala</option>
                           </select>
                        </div>
                    </div>
                    <br>
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-12">
                            <label class="label-asig">CURP:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" placeholder="CURP" [(ngModel)]="empleados.curp" (ngModelChange)="empleados.curp = $event.toUpperCase()" size="20" required>
                        </div>

                    </div>
                    <br>
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-6">
                            <label class="label-asig">Plaza:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" placeholder="Plaza" [(ngModel)]="empleados.plaza" (ngModelChange)="empleados.plaza = $event.toUpperCase()" size="20" required>
                        </div>
                        <div class="col col-lg-6">
                            <label class="label-asig">Tipo de trabajador:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" placeholder="Tipo de trabajador" [(ngModel)]="empleados.tipo_trabajador" (ngModelChange)="empleados.tipo_trabajador = $event.toUpperCase()" size="20" required>
                        </div>
                    </div>
                    <br>
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-6">
                            <label class="label-asig">Puesto:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" placeholder="Puesto" [(ngModel)]="empleados.puesto" (ngModelChange)="empleados.puesto = $event.toUpperCase()" size="20" required>
                        </div>
                        <div class="col col-lg-6">
                            <label class="label-asig">Correo institucional:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" placeholder="Correo institucional" [(ngModel)]="empleados.email" size="20" required>
                        </div>
                    </div>


                </div>
            </div>

            <div class="modal-footer-asig">
                <button type="button" class="btn-guardar" (click)="guardarempleado()" data-dismiss="modal">Guardar</button>
                <button type="button" class="btn-cancelar" data-dismiss="modal">Cerrar</button>

            </div>

        </div>
    </div>
</div>
<div class="modal fade bd-example-modal-lg" id="Editarempleado" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="dialog">
        <div class="modal-content modal-asig">

            <!-- HEADER -->
            <div class="modal-header-asig">
                <h2 class="modal-title-asig">EDITAR RESGUARDANTE</h2>
            </div>

            <!-- BODY -->
            <div class="modal-body-asig">
                <div class="container-asig">
                    <!-- SECCIÓN 1 -->
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-4">
                            <label class="label-asig">Número de empleado:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" [(ngModel)]="empleados.numpersonal" size="20" required>
                        </div>
                        <div class="col col-lg-8">
                            <label class="label-asig">Nombre completo:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" placeholder="Nombre completo" [(ngModel)]="empleados.nombre" (ngModelChange)="empleados.nombre = $event.toUpperCase()" size="20" required>
                        </div>

                    </div>
                    <br>
                    <div class="row justify-content-md-center">

                        <div class="col col-lg-6">
                            <label class="label-asig">Apellido paterno:</label>
                            <input type="text" id="clave" class="form-control-asig disabled-asig" placeholder="Apellido paterno" [(ngModel)]="empleados.appaterno" (ngModelChange)="empleados.appaterno = $event.toUpperCase()" size="20" required>
                        </div>
                        <div class="col col-lg-6">
                            <label class="label-asig">Apellido materno:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" placeholder="Apellido materno" [(ngModel)]="empleados.apmaterno" (ngModelChange)="empleados.apmaterno = $event.toUpperCase()" size="20" required>

                        </div>
                    </div>
                    <br>



                    <div class="row justify-content-md-center">
                        <div class="col col-lg-7">
                            <label class="label-asig">RFC:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" placeholder="RFC" [(ngModel)]="empleados.rfc" (ngModelChange)="empleados.rfc = $event.toUpperCase()" size="20" required>
                        </div>
                        <div class="col col-lg-5">
                            <label class="label-asig">Plantel:</label>
                            <select class="form-control-asig disabled-asig" name="Monitor" [(ngModel)]="empleados.idplantel" required> 
                           <option value="0"> Dirección General</option>
                          <option value="1"> Tres Valles</option>
                          <option value="2"> Papantla</option>
                          <option value="3"> Benito Juárez</option>
                          <option value="4"> Naolinco</option>
                          <option value="5"> Vega de Alatorre</option>
                          <option value="6"> Huitzila</option>
                          <option value="7"> Coxquihui</option>
                          <option value="8"> Uxpanapa</option>
                          <option value="9"> Huayacocotla</option>
                          <option value="10"> Agua Dulce</option>
                          <option value="11"> Pajapan</option>
                          <option value="12"> Filomeno Mata</option>
                          <option value="13"> Platón Sánchez</option>
                          <option value="14"> Atzalan</option>
                          <option value="15"> San Rafael</option>
                          <option value="16"> Omealca</option>
                          <option value="17"> Huatusco</option>
                          <option value="18"> La Camelia</option>
                          <option value="19"> Ciudad Olmeca</option>
                          <option value="20"> Las Lomas</option>
                          <option value="21"> Guayalejo</option>
                          <option value="22"> Medellin</option>
                          <option value="23"> La Cuesta</option>
                          <option value="24"> Huazuntlán</option>
                          <option value="25"> Otatitlan</option>
                          <option value="26"> Catemaco</option>
                          <option value="27"> Palma Sola</option>
                          <option value="28"> Veracruz</option>
                          <option value="29"> General Alatriste</option>
                          <option value="30"> Palo Blanco</option>
                          <option value="31"> Coetzala</option>
                           </select>
                        </div>
                    </div>
                    <br>
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-12">
                            <label class="label-asig">CURP:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" placeholder="CURP" [(ngModel)]="empleados.curp" (ngModelChange)="empleados.curp = $event.toUpperCase()" size="20" required>
                        </div>

                    </div>

                    <br>
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-6">
                            <label class="label-asig">Plaza:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" placeholder="Plaza" [(ngModel)]="empleados.plaza" (ngModelChange)="empleados.plaza = $event.toUpperCase()" size="20" required>
                        </div>
                        <div class="col col-lg-6">
                            <label class="label-asig">Tipo de trabajador:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" placeholder="Tipo de trabajador" [(ngModel)]="empleados.tipo_trabajador" (ngModelChange)="empleados.tipo_trabajador = $event.toUpperCase()" size="20" required>
                        </div>
                    </div>
                    <br>
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-6">
                            <label class="label-asig">Puesto:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" placeholder="Puesto" [(ngModel)]="empleados.puesto" (ngModelChange)="empleados.puesto = $event.toUpperCase()" size="20" required>
                        </div>
                        <div class="col col-lg-6">
                            <label class="label-asig">Correo institucional:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" placeholder="Correo institucional" [(ngModel)]="empleados.email" size="20" required>
                        </div>
                    </div>

                </div>
            </div>

            <div class="modal-footer-asig">
                <button type="button" class="btn-guardar" (click)="editarproveedor()" data-dismiss="modal">Guardar</button>
                <button type="button" class="btn-cancelar" data-dismiss="modal">Cerrar</button>

            </div>

        </div>
    </div>
</div>
<div class="modal fade bd-example-modal-lg" id="Verempleado" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="dialog">
        <div class="modal-content modal-asig">

            <!-- HEADER -->
            <div class="modal-header-asig">
                <h2 class="modal-title-asig">INFORMACIÓN RESGUARDANTE</h2>
            </div>

            <!-- BODY -->
            <div class="modal-body-asig">
                <div class="container-asig">
                    <!-- SECCIÓN 1 -->
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-4">
                            <label class="label-asig">Número de empleado:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" [(ngModel)]="empleados.numpersonal" size="20" required disabled>
                        </div>
                        <div class="col col-lg-8">
                            <label class="label-asig">Nombre completo:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" placeholder="Nombre completo" [(ngModel)]="empleados.nombre" (ngModelChange)="empleados.nombre = $event.toUpperCase()" size="20" required disabled>
                        </div>

                    </div>
                    <br>
                    <div class="row justify-content-md-center">

                        <div class="col col-lg-6">
                            <label class="label-asig">Apellido paterno:</label>
                            <input type="text" id="clave" class="form-control-asig disabled-asig" placeholder="Apellido paterno" [(ngModel)]="empleados.appaterno" (ngModelChange)="empleados.appaterno = $event.toUpperCase()" size="20" required disabled>
                        </div>
                        <div class="col col-lg-6">
                            <label class="label-asig">Apellido materno:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" placeholder="Apellido materno" [(ngModel)]="empleados.apmaterno" (ngModelChange)="empleados.apmaterno = $event.toUpperCase()" size="20" required disabled>

                        </div>
                    </div>
                    <br>



                    <div class="row justify-content-md-center">
                        <div class="col col-lg-7">
                            <label class="label-asig">RFC:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" placeholder="RFC" [(ngModel)]="empleados.rfc" (ngModelChange)="empleados.rfc = $event.toUpperCase()" size="20" required disabled>
                        </div>
                        <div class="col col-lg-5">
                            <label class="label-asig">Plantel:</label>
                            <select class="form-control-asig disabled-asig" name="Monitor" [(ngModel)]="empleados.idplantel" required disabled> 
                           <option value="0"> Dirección General</option>
                          <option value="1"> Tres Valles</option>
                          <option value="2"> Papantla</option>
                          <option value="3"> Benito Juárez</option>
                          <option value="4"> Naolinco</option>
                          <option value="5"> Vega de Alatorre</option>
                          <option value="6"> Huitzila</option>
                          <option value="7"> Coxquihui</option>
                          <option value="8"> Uxpanapa</option>
                          <option value="9"> Huayacocotla</option>
                          <option value="10"> Agua Dulce</option>
                          <option value="11"> Pajapan</option>
                          <option value="12"> Filomeno Mata</option>
                          <option value="13"> Platón Sánchez</option>
                          <option value="14"> Atzalan</option>
                          <option value="15"> San Rafael</option>
                          <option value="16"> Omealca</option>
                          <option value="17"> Huatusco</option>
                          <option value="18"> La Camelia</option>
                          <option value="19"> Ciudad Olmeca</option>
                          <option value="20"> Las Lomas</option>
                          <option value="21"> Guayalejo</option>
                          <option value="22"> Medellin</option>
                          <option value="23"> La Cuesta</option>
                          <option value="24"> Huazuntlán</option>
                          <option value="25"> Otatitlan</option>
                          <option value="26"> Catemaco</option>
                          <option value="27"> Palma Sola</option>
                          <option value="28"> Veracruz</option>
                          <option value="29"> General Alatriste</option>
                          <option value="30"> Palo Blanco</option>
                          <option value="31"> Coetzala</option>
                           </select>
                        </div>
                    </div>
                    <br>
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-12">
                            <label class="label-asig">CURP:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" placeholder="CURP" [(ngModel)]="empleados.curp" (ngModelChange)="empleados.curp = $event.toUpperCase()" size="20" required disabled>
                        </div>

                    </div>
                    <br>
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-6">
                            <label class="label-asig">Plaza:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" placeholder="Plaza" [(ngModel)]="empleados.plaza" (ngModelChange)="empleados.plaza = $event.toUpperCase()" size="20" required disabled>
                        </div>
                        <div class="col col-lg-6">
                            <label class="label-asig">Tipo de trabajador:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" placeholder="Tipo de trabajador" [(ngModel)]="empleados.tipo_trabajador" (ngModelChange)="empleados.tipo_trabajador = $event.toUpperCase()" size="20" required disabled>
                        </div>
                    </div>
                    <br>
                    <div class="row justify-content-md-center">
                        <div class="col col-lg-6">
                            <label class="label-asig">Puesto:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" placeholder="Puesto" [(ngModel)]="empleados.puesto" (ngModelChange)="empleados.puesto = $event.toUpperCase()" size="20" required disabled>
                        </div>
                        <div class="col col-lg-6">
                            <label class="label-asig">Correo institucional:</label>
                            <input type="text" id='clave' class="form-control-asig disabled-asig" placeholder="Correo institucional" [(ngModel)]="empleados.email" size="20" required disabled>
                        </div>
                    </div>

                </div>
            </div>

            <div class="modal-footer-asig">
                <button type="button" class="btn-cancelar" data-dismiss="modal">Cerrar</button>

            </div>

        </div>
    </div>
</div>